module.exports = __webpack_public_path__ + "static/fairchance_card_img4@2x-ed9f012ccd0d56460b99e39b2b0dea48.jpg";